/*
 * @Author: Tina Huang
 * @Date: 2024-01-23 13:35:03
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-06 14:03:08
 * @Description:
 */
import { NAV_MENU } from '../constants/navs'
import { useNavigate } from 'react-router-dom'
import styles from './nav.module.css'
import { Badge, Button, Tag } from 'antd'
import { Picks } from '@/constants/picks'
import { times, effes, others } from '@/constants/libs'

const NavItem = (props: any) => {
  const { item, isMobile } = props
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(item.path)
  }

  const checkTimestamp = (timestamp: string) => {
    return timestamp && Math.abs(+timestamp - new Date().getTime()) <= 7 * 24 * 60 * 60 * 1000
  }

  const checkUpdate = (item: any) => {
    if (item.key === 'libs' || item.key === 'picks') {
      if (item.key === 'libs') {
        const _list = [...times, ...effes, ...others]
        if (_list.find((cur) => cur?.timestamp && checkTimestamp(cur?.timestamp))) {
          return true
        }
      } else {
        if (Picks.find((cur) => cur?.created && checkTimestamp(cur?.created))) {
          return true
        }
      }
    }
    return false
  }

  const Content = isMobile ? (
    <div key={item.key} onClick={handleClick} className="w-1/5 text-center mt-10">
      <div>
        <h1>
          <img src={item?.logo} className="m-auto" alt="" />
        </h1>
        <p>{item?.name}</p>
      </div>
    </div>
  ) : (
    <div className={styles.homeNav} key={item.key} onClick={handleClick}>
      {checkUpdate(item) && (
        <Tag color="#cd201f" className={styles.homeNav_badge}>
          {item.key === 'libs' ? '新组件' : '新模版'}
        </Tag>
      )}
      {/* <div className={styles.pointWrapper}>
        <i className={styles.point0}></i>
        <i className={styles.point1}></i>
      </div> */}
      <div className={styles.name}>
        <h1>
          <img src={item?.logo} alt="" />
        </h1>
        <p>{item?.name}</p>
      </div>
      <p className={styles.detailDesc}>{item?.desc}</p>
      <Button className={styles.navBtn} type="primary" shape="round" onClick={handleClick}>
        立即体验
      </Button>
    </div>
  )

  return <>{Content}</>
}

export default function HomeNav() {
  const isMobile = window.innerWidth <= 750
  return (
    <div className={`flex w-full ${isMobile ? 'flex-wrap justify-center' : 'justify-between'}`}>
      {NAV_MENU.map((item, index) =>
        item?.update ? (
          <Badge.Ribbon text={item?.update_msg || '更新'} color="red">
            <NavItem index={index} item={item} key={item.key} isMobile={isMobile}></NavItem>
          </Badge.Ribbon>
        ) : (
          <NavItem index={index} item={item} key={item.key} isMobile={isMobile}></NavItem>
        )
      )}
    </div>
  )
}
